import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { SessionService } from 'app/store/services/session.service';
import { IUserSessionData } from 'app/store/models/user.model';
import { takeUntil } from 'rxjs/operators';
import { FormGroup, FormControl } from '@angular/forms';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';

@Component({
  selector: 'app-prefs-pipeline',
  templateUrl: './prefs-pipeline.component.html',
  styleUrls: ['./prefs-pipeline.component.scss'],
})
export class PrefsPipelineComponent implements OnInit, OnDestroy {
  sessionData: IUserSessionData;
  formGroup: FormGroup;

  cancelButtonProperties: Button = {
    text: 'Cancel',
    color: ButtonColor.WHITE,
    size: ButtonSize.SMALL,
    route: ['/accounts', 'settings'],
  };

  finishButtonProperties: Button = {
    text: 'Finish',
    color: ButtonColor.ORANGE,
    size: ButtonSize.SMALL,
    onClick: () => console.log('finish'),
  };

  noButtonProperties: Button = {
    text: 'No',
    color: ButtonColor.BLUE,
    size: ButtonSize.SMALL,
    onClick: () => this.disableForm(),
  };

  yesButtonProperties: Button = {
    text: 'Yes',
    color: ButtonColor.BLUE,
    size: ButtonSize.SMALL,
    onClick: () => this.enableForm(),
  };

  private destroy$: Subject<boolean> = new Subject<boolean>();
  private enablePipeline: boolean;

  constructor(
    private router: Router,
    private sessionService: SessionService
  ) {}

  ngOnInit() {
    /**
     * TODO: get the current pipelines
     */
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.sessionData = sessionData;

        this.formGroup = new FormGroup({
          label1: new FormControl(),
          label2: new FormControl(),
          label3: new FormControl(),
          label4: new FormControl(),
          label5: new FormControl(),
          label6: new FormControl(),
          label7: new FormControl(),
          label8: new FormControl(),
          label9: new FormControl(),
          label10: new FormControl(),
        });

        this.disableForm();
      });
  }

  enableForm() {
    this.formGroup.enable();
    this.enablePipeline = true;
  }

  disableForm() {
    this.formGroup.disable();
    this.enablePipeline = false;
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }
}
